import { Anchor, Box, Breadcrumbs, Button, Card, Grid, Group, List, Text } from '@mantine/core';
import { IconPlayerPlay } from '@tabler/icons-react';
import { useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import AbTestConfiguration from '../../../components/AbTest/AbTestConfiguration';
import ErrorMessage from '../../../components/ErrorMessage';
import LockableButton from '../../../components/Lockable/LockableButton';
import Metadata from '../../../components/Metadata';
import ConfirmationModal from '../../../components/Modals/ConfirmationModal';
import { Page } from '../../../constants/pageTitles';
import useFetch from '../../../helpers/useFetch';

const page = `${Page['abTests']}`;

const defaultABTest = {
  controlGroupFraction: 5000,
  hypothesis: 'oneSided',
  running: false,
};

const AbTestsNewPage = () => {
  const { accountId, domainId } = useParams();
  const fetchUrl = `/api/admin/accounts/${accountId}/domains/${domainId}/abTests`;
  const fetch = useFetch();
  const navigate = useNavigate();
  const [abTest, setAbTest] = useState(defaultABTest);
  const [confirmStart, setConfirmStart] = useState(false);
  const [userError, setUserError] = useState();

  const createAbTest = (abTest) => {
    const abTestStarted = { ...abTest, running: true };

    fetch(fetchUrl, {
      method: 'POST',
      body: JSON.stringify(abTestStarted),
    })
      .then(() => {
        navigate(`/accounts/${accountId}/domains/${domainId}/abTests`);
      })
      .catch(setUserError);
  };

  const backButton = (
    <Button variant="default" onClick={() => navigate(-1)}>
      Back
    </Button>
  );

  const startButton = (
    <LockableButton restrictionKey="abTestsCreate" onClick={() => setConfirmStart(true)}>
      Start <IconPlayerPlay size={14} />
    </LockableButton>
  );

  const breadcrumbItems = [
    { title: 'Home', href: `#/accounts/${accountId}/domains/${domainId}/analytics` },
    { title: page, href: `#/accounts/${accountId}/domains/${domainId}/abTests` },
    { title: 'New' },
  ].map((item, index) => (
    <Anchor href={item.href} key={index}>
      {item.title}
    </Anchor>
  ));

  return (
    <>
      <Metadata title={`${page} | New`} />
      <Breadcrumbs mb="md">{breadcrumbItems}</Breadcrumbs>
      <ConfirmationModal
        show={confirmStart}
        close={() => setConfirmStart(false)}
        confirm={() => createAbTest(abTest)}
        message={
          <>
            <Text>Starting an A/B test will reduce the number of users targeted by Releva, which means:</Text>
            <List size="sm" c="dimmed">
              <List.Item>
                <Text fw={700} component="span">
                  Fewer
                </Text>{' '}
                users will see product blocks and banners on your website.
              </List.Item>
              <List.Item>
                <Text fw={700} component="span">
                  Fewer
                </Text>{' '}
                users will enter your campaigns and receive your newsletters.
              </List.Item>
            </List>
          </>
        }
      />

      <Grid>
        <Grid.Col span={12}>
          <Card withBorder>
            <AbTestConfiguration abTest={abTest} setAbTest={setAbTest} />
            <Group justify="flex-end" gap="xs" py="md">
              {backButton}
              {startButton}
            </Group>
          </Card>
        </Grid.Col>
      </Grid>
      {userError ? (
        <Box ta="right">
          <ErrorMessage message={userError.message} />
        </Box>
      ) : null}
    </>
  );
};

export default AbTestsNewPage;
